import { getCountry } from './country.service'

const getMapCenter = () => {
  const mapCenters = {
    HK: { lat: 22.358731, lng: 114.076109 },
    SG: { lat: 1.2958912, lng: 103.8579038 },
    TW: { lat: 25.0336076, lng: 121.5647587 },
    VN: { lat: 10.823100, lng: 106.629700 },
    IN: { lat: 13.0418, lng: 80.2341 },
  }
  const country = getCountry()

  return mapCenters[country]
}

const getDefaultZoom = () => {
  const defaultZoom = {
    HK: 11,
    SG: 13,
    TW: 13,
    VN: 14,
    IN: 14,
  }
  const country = getCountry()

  return defaultZoom[country]
}

export { getMapCenter, getDefaultZoom }
